import { Kbd, KbdGroup } from "@/components/atoms/kbd";

export const RteTooltipWithShortcut = ({
  label,
  keys,
}: {
  label: string;
  keys: readonly string[];
}) => (
  <>
    {label}{" "}
    <KbdGroup>
      {keys.map((k, i) => (
        <Kbd key={`${label}→${keys.slice(0, i + 1).join("→")}`}>{k}</Kbd>
      ))}
    </KbdGroup>
  </>
);
